export default "__VITE_ASSET__DK0oxQyb__"